import axios from 'axios'
import util from '../util/asymmetric'

let token = util.asymmetric()

export default axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    token: token,
  },
})
